export const defaultValues = {
  name: "",
  username: "",
  password: "",
  pairCode: "",
  paymentMethodId: "",
};
